module.exports = __webpack_public_path__ + "static/media/tagluffa_square.13ff0af8.png";